import NewCandidateApplicationsHandler from "../../utils/analytics/NewCandidateApplicationsHandler";
import CandidateApplicationFunnelHandler from "../../utils/analytics/CandidateApplicationFunnelHandler";
import RejectionCountsHandler from "../../utils/analytics/RejectionCountsHandler";
import HireCountsHandler from "../../utils/analytics/HireCountsHandler";
import InterviewCountsHandler from "../../utils/analytics/InterviewCountsHandler";
import InterviewScoreCountsHandler from "../../utils/analytics/InterviewScoreCountsHandler";
import ApplicantToInterviewHandler from "../../utils/analytics/ApplicantToInterviewHandler";
import InterviewToOfferHandler from "../../utils/analytics/InterviewToOfferHandler";
import OfferToJoinHandler from "../../utils/analytics/OfferToJoinHandler";
import NewStageTimeHandler from "../../utils/analytics/NewStageTimeHandler";
import ScreenStageTimeHandler from "../../utils/analytics/ScreenStageTimeHandler";
import InterviewStageTimeHandler from "../../utils/analytics/InterviewStageTimeHandler";
import OfferStageTimeHandler from "../../utils/analytics/OfferStageTimeHandler";
import TimeToCloseHandler from "../../utils/analytics/TimeToCloseHandler";
import TimeToOfferHandler from "../../utils/analytics/TimeToOfferHandler";
import { RequisitionTitleWithState } from "../requisitions/RequisitionStateBadge";

export const masterMetricDetails = {
  // candidate_application_stage_wise_counts: {
  //   filters: ["job", "ta_handler", "source", "stage"],
  //   label: "Candidate application (stage-wise)",
  //   group_by: [],
  //   klass: CandidateApplicationStageWiseCountsHandler,
  // },
  new_candidate_applications: {
    filters: ["job", "source"],
    label: "New candidates",
    group_by: ["job", "source"],
    klass: NewCandidateApplicationsHandler,
    availableFree: true,
  },
  candidate_application_funnel: {
    filters: ["job", "source", "ta_handler"],
    label: "Candidate application funnel",
    group_by: [],
    klass: CandidateApplicationFunnelHandler,
  },
  rejection_counts: {
    filters: ["job", "source", "ta_handler"],
    label: "Rejection counts",
    group_by: ["source"],
    klass: RejectionCountsHandler,
    availableFree: true,
  },
  hire_counts: {
    filters: ["job", "source", "ta_handler"],
    label: "Hire counts",
    group_by: ["job", "source"],
    klass: HireCountsHandler,
    availableFree: true,
  },
  applicant_to_interview: {
    filters: ["job", "source", "ta_handler"],
    label: "Applicant to Interview (%)",
    group_by: ["job", "source", "ta_handler"],
    klass: ApplicantToInterviewHandler,
  },
  interview_to_offer: {
    filters: ["job", "source", "ta_handler"],
    label: "Interview to Offer (%)",
    group_by: ["job", "source", "ta_handler"],
    klass: InterviewToOfferHandler,
  },
  offer_to_join: {
    filters: ["job", "source", "ta_handler"],
    label: "Offer to Join (%)",
    group_by: ["job", "source", "ta_handler"],
    klass: OfferToJoinHandler,
  },
  interview_counts: {
    filters: ["job", "source", "ta_handler", "panel"],
    label: "Interview counts",
    group_by: ["panel", "round_number"],
    klass: InterviewCountsHandler,
    availableFree: true,
  },
  interview_score_counts: {
    filters: ["job", "source", "ta_handler", "panel"],
    label: "Interview score counts",
    group_by: [],
    klass: InterviewScoreCountsHandler,
  },
  new_stage_time: {
    filters: ["job", "source", "ta_handler"],
    label: "Time in New stage",
    group_by: ["job", "source", "ta_handler"],
    klass: NewStageTimeHandler,
    availableFree: true,
  },
  screen_stage_time: {
    filters: ["job", "source", "ta_handler"],
    label: "Time in Screen stage",
    group_by: ["job", "source", "ta_handler"],
    klass: ScreenStageTimeHandler,
  },
  interview_stage_time: {
    filters: ["job", "source", "ta_handler"],
    label: "Time in Interview stage",
    group_by: ["job", "source", "ta_handler"],
    klass: InterviewStageTimeHandler,
  },
  offer_stage_time: {
    filters: ["job", "source", "ta_handler"],
    label: "Time in Offer stage",
    group_by: ["job", "source", "ta_handler"],
    klass: OfferStageTimeHandler,
  },
  time_to_offer: {
    filters: ["job", "source", "ta_handler"],
    label: "Time to offer",
    group_by: ["job", "source", "ta_handler"],
    klass: TimeToOfferHandler,
  },
  time_to_close: {
    filters: ["job", "source", "ta_handler"],
    label: "Time to close",
    group_by: ["job", "source", "ta_handler"],
    klass: TimeToCloseHandler,
  },
};

export const filterMapping = {
  job: {
    dataFetchPath: "requisitions",
    multiSelect: true,
    label: "Job",
    getOptionLabel: (option) => option.title,
    getOptionSelected: (option, value) => value && option.id === value.id,
    getValueIdentifier: (option) => option.id,
    responseMapper: (response) => response.requisitions,
    renderOption: (option) => (
      <RequisitionTitleWithState title={option.title} state={option.state} />
    ),
  },
  source: {
    dataFetchPath: "candidate-application/get-allowed-sources",
    label: "Source",
    multiSelect: true,
    getOptionSelected: (option, value) => value && option.value === value.value,
    getOptionLabel: (option) => option.title,
    getValueIdentifier: (option) => option.title,
    responseMapper: (response) => response.sources,
  },
  ta_handler: {
    dataFetchPath: "users/list",
    label: "TA handler",
    multiSelect: true,
    getValueIdentifier: (option) => option.id,
    getOptionSelected: (option, value) => value && option.id === value.id,
    getOptionLabel: (option) => option.name,
    responseMapper: (response) => response.users,
  },
  panel: {
    dataFetchPath: "users/list",
    label: "Panel",
    multiSelect: true,
    getValueIdentifier: (option) => option.id,
    getOptionLabel: (option) => option.name,
    getOptionSelected: (option, value) => value && option.id === value.id,
    responseMapper: (response) => response.users,
  },
  stage: {
    dataFetchPath: "candidate-applications/get-stages",
    label: "Stage",
    getValueIdentifier: (option) => option.value,
    getOptionSelected: (option, value) => value && option.value === value.value,
    multiSelect: true,
    getOptionLabel: (option) => option.label,
    responseMapper: (response) => response.stages,
  },
};

export const groupByMapping = {
  job: {
    label: "Job",
  },
  source: {
    label: "Source",
  },
  ta_handler: {
    label: "TA Handler",
  },
  panel: {
    label: "Panel",
  },
  state: {
    label: "State",
  },
  stage: {
    label: "Stage",
  },
  round_number: {
    label: "Round Number",
  },
};
